import React, { Dispatch, FunctionComponent, SetStateAction, useState } from 'react';
import { percentageWidthStyle } from '../../../utils/format';

export type MetaInfo = {
  name: string;
};

type WizardFinalStepProps = {
  steps: number;
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  setMetaInfo: Dispatch<SetStateAction<MetaInfo | undefined>>;
};

const WizardFinalStep: FunctionComponent<WizardFinalStepProps> = ({ steps, step, setStep, setMetaInfo }) => {
  const [envName, setEnvName] = useState<string | undefined>(undefined);

  const submitInfo = () => {
    if (envName) {
      setMetaInfo({
        name: envName
      });
      setStep(step + 1);
    }
  };

  return (
    <div className="basis-11/12 md:basis-7/12 md:px-0 px-4">
      <div className="border-b-2 py-4">
        <div className="uppercase tracking-wide text-xs font-bold text-gray-500 mb-1 leading-tight">
          Step {step} of {steps}
        </div>
        <div className="flex flex-row items-center justify-between py-2">
          <div className="basis-1/2">
            <div className="text-lg font-bold text-gray-700 leading-tight left">Confirmation</div>
          </div>

          <div className="basis-1/2 flex-row flex items-center px-3">
            <div className="flex-auto bg-gray-200 rounded-full mr-2">
              <div
                className="rounded-full bg-green-500 text-xs leading-none h-2 text-center text-white"
                style={percentageWidthStyle(step / steps)}
              />
            </div>
            <div className="flex-none text-xs w-10 text-gray-600">
              {Math.round((step / steps) * 100).toFixed(0) + '%'}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col py-10">
        <div className="mb-6 w-2/3">
          <label htmlFor="envName" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">
            Environment Name
          </label>
          <input
            id="envName"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="My Awesome Environment"
            onChange={(e) => setEnvName(e.target.value)}
          />
        </div>

        <div className="flex flex-row pt-10 justify-end">
          {envName && (
            <button
              type="button"
              onClick={submitInfo}
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Create
            </button>
          )}
          {!envName && (
            <button
              type="button"
              className="text-white bg-blue-400 dark:bg-blue-500 cursor-not-allowed font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              Create
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default WizardFinalStep;
